/** Compare two values for sorting. Returns -1, 0, or 1. */
export const sortCompare = <T extends string | number | Date>(a: T, b: T) =>
  a < b ? -1 : a > b ? 1 : 0;
